module.exports = __webpack_public_path__ + "static/media/8.dd019532.png";